module.exports = __webpack_public_path__ + "77ccd07ec861f520bd184374e19c262e.pdf";